<template lang="pug">
	div
		sfc-menu
		sfc-menu-mobile
</template>

<script>
import SfcMenu from '@/layouts/common/redesign-v1/sfc-menu-v2'
import SfcMenuMobile from '@/layouts/common/redesign-v1/sfc-menu-mobile-v2'
export default {
	components: {
		SfcMenu,
		SfcMenuMobile
	}
}
</script>
